import { ChartDataArray } from '../data/ChartDataArray';
import { ColumnBarChartAttrHandler } from './ColumnBarChartAttrHandler';
import { StackedRenderer } from './StackedRenderer';

export class StackedColumnBarRenderer extends StackedRenderer {
  protected static readonly PADDING = 8;

  constructor(
    private gElement: d3.Selection<SVGGElement, unknown, null, undefined>,
    filled: boolean
  ) {
    super(filled);
  }

  protected renderInternal(
    arrays: ChartDataArray[],
    handlers: ColumnBarChartAttrHandler,
    limit?: number,
    inverted?: boolean
  ) {
    const keys = StackedRenderer.getKeys(arrays, limit, inverted);
    const series = super.createSeries(arrays, keys, limit, inverted);

    this.gElement
      .append('g')
      .selectAll('g')
      .data(series)
      .enter()
      .append('g')
      .attr('class', (_, i) => 'chart-color-' + (series.length - i - 1))
      .style('fill', (d, _) => arrays.find(ele => ele.label === d.key)!.color || null)
      .attr('data-key-index', d => keys.indexOf(d.key)) // make outer index available for subgroups
      .selectAll('rect')
      .data(d => d)
      .enter()
      .append('rect')
      .attr('x', (d, i) => handlers.x!(d, i)!)
      .attr('y', handlers.y!)
      .attr('height', handlers.height!)
      .attr('width', handlers.width!);
  }

  switchHighlight(_index: number, _highlight: boolean) {
    throw new Error('Method not implemented.');
  }
}
